<template>
  <div class="meeting-doc_wrapper" :style="customStyle">
    <div class="meeting-doc__content">
      <div
        class="meeting-doc__content-items"
        v-for="item in data"
        :key="item.expoMeetingDocCode"
      >
        <div class="doc__content-main">
          <div
            class="doc__content-file__suffix"
            :style="{
              'background-color': getFileSuffixMarkColor(item.fileName),
            }"
          >
            {{ splitFileSuffix(item.fileName) }}
          </div>
          <div class="doc__content-file__name">
            <div class="d-flex">
              <div v-if="item.isCustomer == 'Y'" class="doc__content-icon mr-2">
                <img :src="emailSecurityIcon" />
              </div>
              <p class="doc__content-file__name_wrapper">{{ item.fileName }}</p>
            </div>
            <div class="doc__content-file__desc">
              {{ item.remark }}
            </div>
          </div>
        </div>
        <div class="doc__content-opts">
          <div class="doc__content-file__name">
            {{ item.uploadByName }}
            {{ item.uploadLocalTime }}
          </div>
          <div class="d-flex align-items-center icon_content ml-2">
            <i class="el-icon-delete mr-3" @click="deleteFile(item)" />
            <i class="el-icon-view mr-3" @click="viewFile(item)" />
            <i class="el-icon-download" @click="downloadFile(item)" />
          </div>
        </div>
      </div>
    </div>
    <UploadDoc
      :visible="showUploadDoc"
      :expoMeetingCode="expoMeetingCode"
      :tskRemarkCode="tskRemarkCode"
      :tskInfoCode="tskInfoCode"
      @upload="getData"
      @close="close"
      :title="$l('dialog_title_upload_doc') || '上传文档'"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import UploadDoc from './upload-doc'
import EditLoading from '@/mixins/edit-loading'
const emailSecurityIcon = require('./emailSecurity@3x.png')
export default {
  mixins: [EditLoading],
  props: {
    expoMeetingCode: { type: String, default: '' },
    tskInfoCode: { type: String, default: '' },
    tskRemarkCode: { type: String, default: '' },
    customStyle: { type: String, default: '' },
    isCustomer: { type: String, default: 'N' },
  },
  components: { UploadDoc },
  data() {
    return {
      localTimeZone: '',
      loading: false,
      showUploadDoc: false,
      data: [],
      fileMarkColor: {
        'jpg,jpeg,png,gif,bmp,tiff,webp,svg': '#15A2B8',
        pdf: '#007bff',
        'ppt,pptx': '#E6A23C',
        'doc,docx': '#909399',
        'csv,xlsx,xlsm,xlsb,xltm': '#67C23A',
        zip: '#343a40',
        other: '#DCDFE6',
      },
      emailSecurityIcon,
    }
  },
  computed: {
    isEmpty() {
      return !this.data?.length
    },
  },
  created() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/upload', ['push']),
    async getData() {
      if (!this.tskInfoCode || !this.tskRemarkCode) return
      const localTimeZone = await this.loadLocalTimeZone()
      const params = {
        tskInfoCode: this.tskInfoCode,
        tskRemarkCode: this.tskRemarkCode,
        localTimeZone,
        isCustomer: this.isCustomer,
      }
      this.loading = true
      const res = await this.$api
        .expoTskInfoDocListApi(params)
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.data = res.body.data
    },
    async loadLocalTimeZone() {
      return new Promise((resolve) => {
        if (this.localTimeZone) return resolve(this.localTimeZone)
        const now = new Date()
        const offsetMinutes = now.getTimezoneOffset()
        const offsetHours = Math.abs(Math.floor(offsetMinutes / 60))
        const offsetMinutesRemainder = Math.abs(offsetMinutes % 60)
        const offsetString = `${offsetMinutes >= 0 ? '-' : '+'}${offsetHours
          .toString()
          .padStart(2, '0')}:${offsetMinutesRemainder
          .toString()
          .padStart(2, '0')}`

        this.localTimeZone = offsetString
        resolve(offsetString)
      })
    },
    async uploadFile() {
      this.showUploadDoc = true
    },
    splitFileSuffix(filename) {
      if (!filename) return ''
      const lastIndex = filename.lastIndexOf('.')
      if (lastIndex !== -1) return filename.slice(lastIndex)
      return ''
    },
    getFileSuffixMarkColor(filename) {
      const otherColor = this.fileMarkColor.other
      if (!filename) return otherColor
      const suffix = filename.split('.').pop()

      const types = Object.keys(this.fileMarkColor)

      const typeKey =
        types.filter(
          (type) => type.includes(suffix) || type.toUpperCase().includes(suffix)
        )[0] || ''
      return (
        this.fileMarkColor[typeKey] || this.fileMarkColor[typeKey.toUpperCase()]
      )
    },
    close() {
      this.showUploadDoc = false
      this.getData()
    },
    async deleteFile({ tskInfoDocCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .expoTskInfoDocDelApi({ tskInfoDocCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.getData()
    },
    downloadFile({ fileCode = '' }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode)
    },
    viewFile({ fileCode }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode, { isAutoDown: true, preview: true })
    },
  },
}
</script>
<style lang="scss" scoped>
.meeting-doc_wrapper {
  position: relative;
}
.meeting-doc_wrapper::-webkit-scrollbar {
  width: 0; /* 隐藏滚动条 */
}
.meeting-doc_wrapper .meeting-doc__content {
  line-height: 20px;
  border-radius: 10px;
  font-size: 14px;
  color: rgba(16, 16, 16, 1);
  display: flex;
  flex-wrap: wrap;
}

.meeting-doc_wrapper .meeting-doc__content-items {
  border: 1px solid #bbbbbb;
  overflow: auto;
  border-radius: 5px;
  margin-bottom: 5px;
  padding: 8px;
  --gutter: 10px;
  --span: 1;
  --width: calc(
    calc(100% / var(--span)) -
      calc(var(--gutter) * calc(var(--span) - 1) / var(--span))
  );
  width: var(--width);
}

.meeting-doc_wrapper .meeting-doc__content-items .doc__content-main {
  display: flex;
  .doc__content-file__suffix {
    width: 65px;
    height: 65px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    margin-right: 6px;
  }
  .doc__content-file__name {
    width: calc(100% - 65px - 6px);
    p {
      margin-bottom: 0;
    }
    .doc__content-file__name_wrapper {
      width: 100%;
      line-height: 23px;
      color: #101010;
      display: inline-block;
      font-size: 14px;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .doc__content-file__desc {
      color: #8e8e8e;
      font-size: 12px;
    }
  }
}
.icon_content {
  flex: 1;
  justify-content: end;
}
.doc__content-icon {
  width: 20px;
  height: 20px;
  display: inline-block;
  > img {
    width: 20px;
    height: 20px;
  }
}

.meeting-doc_wrapper .meeting-doc__content-items .doc__content-opts {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;

  i {
    font-size: 20px;
    color: #8e8e8e;
    cursor: pointer;
  }
  div:first-child {
    color: rgba(142, 142, 142, 1);
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
